import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../../../store/services/account.service';
import { IVsmCommentResponse } from '../../../store/models/content.model';
import { ContentService } from '../../../store/services/content.service';
import { IListApiModel } from '../../../store/models/api.model';

@Component({
  selector: 'app-release-replay-action',
  templateUrl: './release-replay-action.component.html',
  styleUrls: ['./release-replay-action.component.scss'],
})
export class ReleaseReplayActionComponent implements OnInit {
  inputForm: FormGroup;
  componentReady = false;
  formReady: boolean;

  managerId?: number;

  managerEmail?: string;

  editorConfig = {};

  constructor(
    private readonly accountService: AccountService,
    private readonly contentService: ContentService,
  ) {
  }

  onEditorReady() {
    this.componentReady = true;
  }

  ngOnInit(): void {
    if (this.managerId) {
      this.accountService.getAccountById(this.managerId).subscribe(
        manager => {
          if (manager && manager.email) {
            this.managerEmail = manager.email;
            this.initForm();
          }
        },
        error => this.initForm(),
      );
    } else {
      this.initForm();
    }
  }

  initForm() {
    this.contentService
      .getVsmComments()
      .subscribe((data: IListApiModel<IVsmCommentResponse>) => {
        this.editorConfig = this.onPreInit(data.items);
        this.inputForm.addControl(
          'note',
          new FormControl('', Validators.required),
        );
        this.inputForm.addControl('ccManager', new FormControl(false));
        this.formReady = true;
      });
  }

  onPreInit(vsmComments: IVsmCommentResponse[]) {
    return {
      toolbar:
        'vsm_comments | undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist',
      plugins: 'link lists',
      setup(editor) {
        /* Menu items are recreated when the menu is closed and opened, so we need
           a variable to store the toggle menu item state. */
        const items = vsmComments.map(item => {
          return {
            type: 'menuitem',
            text: item.name,
            onAction() {
              editor.insertContent(item.response);
            },
          };
        });
        editor.ui.registry.addMenuButton('vsm_comments', {
          text: 'Select Comment',
          fetch(callback) {
            callback(items);
          },
        });
      },
    };
  }
}
